import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useI18n } from "../lib/i18n";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "./ui/dropdown-menu";
import { Bell, AlertTriangle, Globe } from "lucide-react";

export const NotificationBell = () => {
  const { t } = useI18n();
  const navigate = useNavigate();
  const [data, setData] = useState({ low_stock: [], online_new: 0 });

  useEffect(() => {
    const load = () =>
      api
        .get("/reports/summary")
        .then(({ data: d }) =>
          setData({ low_stock: d.low_stock || [], online_new: d.online_new || 0 })
        )
        .catch(() => {});
    load();
    const id = setInterval(load, 30000);
    return () => clearInterval(id);
  }, []);

  const count = data.low_stock.length + data.online_new;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          data-testid="notification-bell"
          className="relative p-2 rounded-xl hover:bg-gray-100 transition-colors duration-200"
        >
          <Bell size={18} className="text-gray-600" />
          {count > 0 && (
            <span
              data-testid="notification-count"
              className="absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] px-1 rounded-full bg-primary text-white text-[10px] font-semibold grid place-items-center"
            >
              {count}
            </span>
          )}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-72" data-testid="notification-menu">
        <DropdownMenuLabel>{t("notifications")}</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {count === 0 && (
          <DropdownMenuItem disabled data-testid="notification-empty">
            {t("all_clear")}
          </DropdownMenuItem>
        )}
        {data.online_new > 0 && (
          <DropdownMenuItem
            data-testid="notification-online"
            onClick={() => navigate("/pesanan")}
            className="gap-2"
          >
            <Globe size={15} className="text-primary" />
            {data.online_new} {t("new_online_orders")}
          </DropdownMenuItem>
        )}
        {data.low_stock.map((p) => (
          <DropdownMenuItem
            key={p.id}
            data-testid={`notification-low-${p.id}`}
            onClick={() => navigate("/stok")}
            className="gap-2"
          >
            <AlertTriangle
              size={15}
              className={p.stock <= 0 ? "text-red-600" : "text-amber-500"}
            />
            <span className="flex-1 truncate">{p.name}</span>
            <span className={`num text-xs ${p.stock <= 0 ? "text-red-600" : "text-amber-600"}`}>
              {p.stock} {p.unit}
            </span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
